import Styles from './MobileSelectImage.module.scss'
import { SelectedImage } from 'types'
import { collectResults } from 'utils/query'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { Button } from 'blaze-ui/Button'
import { Grid } from 'blaze-ui/icons'
import { DragOverlayForFirstUpload } from 'components/Design/UploadsTab/DragOverlay'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import { useEffect, useState } from 'react'
import cx from 'classnames'
import { useInfiniteBrandKitMediaFiles } from 'hooks/queries/brandKits/useInfiniteBrandKitMediaFiles'
import { UploadButton } from 'screens/BrandKit/Media/UploadButton'
import { Checkbox } from 'blaze-ui/Checkbox'

interface Props {
  onMoreClick?: () => void
  brandKitId: number
}

export const BrandKitImages = ({ onMoreClick, brandKitId }: Props) => {
  const imagePickerContext = useImagePickerContext()
  const [resetImage, setResetImage] = useState(false)
  const { selectedImages, toggleSelectedImage } = imagePickerContext
  const mediaFilesQuery = useInfiniteBrandKitMediaFiles({ brandKitId, items: 4 })
  const mediaFiles = collectResults(mediaFilesQuery, (data) => data.media_files)
  const images: SelectedImage[] = mediaFiles.map((mf) => ({ ...mf, url: mf.thumbnail_url as string })).slice(0, 4)

  useEffect(() => {
    if (images.length > 0 && !resetImage) {
      setResetImage(true)
      toggleSelectedImage(images[0])
    }
  }, [mediaFilesQuery.isFetched]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {mediaFilesQuery.isLoading ? (
        <div className={Styles.imagesSection}>
          <div className={Styles.selectedImage}>
            <ShimmeringColor aspectRatio={1} />
          </div>
          <div className={Styles.imagesGrid}>
            {Array.from(Array(4)).map((_, index) => (
              <div key={`loading-${index}`} className={Styles.image}>
                <ShimmeringColor aspectRatio={1} />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
          {images.length > 0 ? (
            <div className={Styles.imagesSection}>
              <img
                className={Styles.selectedImage}
                src={selectedImages[0]?.source_url || selectedImages[0]?.url || images[0]?.source_url}
                alt="library"
              />
              <div className={Styles.imagesGrid}>
                {images.map((file) => (
                  <Checkbox.Label
                    key={file.id}
                    aria-label={`Select brand kit image ${file.source_url}`}
                    isSelected={file.id === selectedImages[0]?.id}
                    onChange={() => toggleSelectedImage(file)}
                  >
                    <div
                      key={file.id}
                      className={cx(Styles.image, { [Styles.isSelected]: file.id === selectedImages[0]?.id })}
                      onClick={() => toggleSelectedImage(file)}
                    >
                      <img src={file.source_url} alt="img" />
                      {file.id === selectedImages[0]?.id && (
                        <div className={Styles.checkbox}>
                          <Checkbox.Box color="var(--selected-stroke)" />
                        </div>
                      )}
                    </div>
                  </Checkbox.Label>
                ))}
              </div>
              <Button frontIcon={Grid} fullWidth variant="secondary" size="lg" onPress={onMoreClick}>
                Select another from my Image Library
              </Button>
            </div>
          ) : (
            <>
              <DragOverlayForFirstUpload
                style={{ aspectRatio: 1, width: '100%', margin: 0 }}
                withSupportedFilesTag={false}
                withDropFilesTag={false}
                buttonProps={{ label: 'Uploads Files', size: 'md', variant: 'primary' }}
                button={(props) => <UploadButton brandKitId={brandKitId} {...props} />}
              />
              <Button frontIcon={Grid} fullWidth variant="secondary" size="lg" onPress={onMoreClick}>
                Select another from my Image Library
              </Button>
            </>
          )}
        </>
      )}
    </>
  )
}
